const ERROR_MESSAGE_OVERRIDES: Record<string, string> = {
  "err-payment-batch-enquiry-cooldown":
    "Enquiry already requested. Please wait 3 minutes before trying again."
};

export function formatReadableErrorMessage(message: string | null | undefined): string {
    if (message == null || message === "") {
      return "";
    }
    if (ERROR_MESSAGE_OVERRIDES[message]) {
      return ERROR_MESSAGE_OVERRIDES[message];
    }
    return message
      .replace(/[-_]+/g, " ")
      .replace(/err/g, "Error")
      .toLowerCase()
      .replace(/\b\w/g, (c: string) => c.toUpperCase());
  }